import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m15.194 13.707 3.814 1.86-1.86 3.814", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Rotate3d";
const Rotate3d = memo(themed(Icon));
export {
  Rotate3d
};
//# sourceMappingURL=rotate-3d.js.map
